/* GlobalMessage.ts */

export enum GlobalMessageType {
  DEFAULT = "default",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
}
